import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["name", "checked"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "dropdown-menu"
}

import { DropdownMenuItem, DropdownSubMenuPosition, MenuType } from "@medapro-types/common/components/DropdownMenu";
import { computed, reactive, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownChildMenuItem',
  props: {
    item: {}
  },
  emits: ["selected", "change"],
  setup(__props: any, { emit }) {

const props = __props;



const menu = computed(() => props.item);



const viewModel = reactive({
  checked: false,
  position: "right" as DropdownSubMenuPosition | undefined
});

const enabled = computed(() => {
  if (!menu.value) {
    return false;
  }

  if (menu.value.enabled === null || menu.value.enabled === undefined) {
    return true;
  }

  if (typeof menu.value.enabled === "boolean") {
    return menu.value.enabled;
  }

  return menu.value.enabled(menu.value);
});

const children = computed(() => menu.value?.children || []);

const submenuPosition = computed(() => {
  if (!menu.value) {
    return "";
  }

  const menuItems = [
    menu.value.subMenuPosition || viewModel.position || "",
    children.value?.length ? " nested-menu" : "",
    isCheckable.value && viewModel.checked ? "checked" : "",
    isCheckable.value ? (menu.value.type === MenuType.CheckboxMenu ? "checkbox-menu" : "radiobutton-menu") : "",
    menu.value.separator === "top" ? "separator-before" : "",
    menu.value.separator === "bottom" ? "separator-after" : ""
  ];

  return menuItems.filter((x) => x);
});

const isCheckable = computed(() => menu.value && (menu.value.type === MenuType.CheckboxMenu || menu.value.type === MenuType.RadiobuttonMenu));

watch(
  () => menu.value?.checked,
  (nv) => {
    if (menu.value?.type !== MenuType.DefaultMenu) {
      viewModel.checked = nv === true;
    } else {
      viewModel.checked = false;
    }
  },
  {
    immediate: true
  }
);

watch(
  () => viewModel.checked,
  (nv) => {
    if (isCheckable.value) {
      setTimeout(() => {
        if (menu.value.changeHandler) {
          menu.value.changeHandler(nv, menu.value);
          emit("change", nv);
        }
      }, 2);
    }
  }
);

function handleClick() {
  // in case of radiobutton menu, a re-checked item does not change anything
  if (menu.value?.type === MenuType.RadiobuttonMenu && viewModel.checked) {
    emit("selected", viewModel.checked);
    return;
  }

  if (menu.value && enabled.value) {
    if (isCheckable.value) {
      viewModel.checked = !viewModel.checked;
    }

    //only pass the state when this menu is checkable.
    const checkedState = isCheckable.value ? viewModel.checked : undefined;
    emit("selected", checkedState);

    setTimeout(() => {
      if (menu.value.clickHandler) {
        menu.value.clickHandler(menu.value, checkedState);
      }
    }, 2);
  }
}

function decidePosition(event: MouseEvent) {
  const element: HTMLElement = event.target as HTMLElement;
  const subMenu: HTMLElement = element.querySelector("ul:first-of-type") as HTMLElement;
  if (subMenu) {
    const left = element.getBoundingClientRect().right;
    const width = subMenu.clientWidth;
    const parent: HTMLElement | null = getScrollParent(subMenu);

    const isEntirelyVisible = left + width <= (parent?.clientWidth || window.innerWidth);

    if (isEntirelyVisible) {
      viewModel.position = "right";
    } else {
      viewModel.position = "left";
    }
  } else {
    viewModel.position = undefined;
  }
}

function getScrollParent(node: HTMLElement): HTMLElement | null {
  const isElement = node instanceof HTMLElement;
  if (!isElement) {
    return null;
  }

  const overflowY: string = window.getComputedStyle(node).overflowY;
  const isScrollable = !(overflowY.includes("hidden") || overflowY.includes("visible"));

  if (!node) {
    return null;
  } else if (isScrollable && node.scrollHeight >= node.clientHeight) {
    return node;
  } else if (!node.parentNode) {
    return (document.scrollingElement || document.body) as HTMLElement;
  }

  return (getScrollParent(node.parentNode as HTMLElement) || document.scrollingElement || document.body) as HTMLElement;
}

return (_ctx: any,_cache: any) => {
  const _component_Dropdown_child_menu_item = _resolveComponent("Dropdown-child-menu-item", true)!
  const _directive_safe_class = _resolveDirective("safe-class")!

  return _withDirectives((_openBlock(), _createElementBlock("li", { onMouseenter: decidePosition }, [
    (isCheckable.value)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "radio",
          name: menu.value.group,
          checked: viewModel.checked,
          class: "hidden"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      class: _normalizeClass(["dropdown-item", { disabled: !enabled.value }]),
      href: "#",
      onClick: _withModifiers(handleClick, ["prevent"])
    }, [
      (menu.value.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(menu.value?.icon)
          }, null, 2))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(menu.value?.text), 1)
    ], 10, _hoisted_2),
    (children.value?.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children.value, (entry, index) => {
            return (_openBlock(), _createBlock(_component_Dropdown_child_menu_item, {
              item: entry,
              key: index,
              onSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected', $event)))
            }, null, 8, ["item"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 32)), [
    [_directive_safe_class, submenuPosition.value]
  ])
}
}

})